import React from 'react';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { notFound as NotFound } from 'ui/views/layouts/notFound';
 *
 * // render
 * <NotFound propName='propValue'/>
 */
export const notFound = () => {
    return (
        <div className='ui-not-found'>
            <p>Not Found...</p>
        </div>
    );
};

// set display name
notFound.displayName = 'notFound';

// set default props
notFound.defaultProps = {};

// prop types
notFound.propTypes = {};
